import React from 'react';
import {
    ApTimelineRow,
    ApTimelineMetadata,
    ApTimelineMarker,
} from '@accurate-player/accurate-player-components-external';
import {
    Typography,
    ButtonBase,
} from '@material-ui/core';
import {
    Visibility,
    VisibilityOff,
} from '@material-ui/icons';
import QCTooltip from '@pluto/qc-tooltip';
import classNames from 'classnames';
import {
    TimelineRow,
    TooltipMarker,
    TooltipMarkerOrUndefined,
} from '../../../Timeline/TimelineTypes';
import Tooltip from '../Tooltip/TooltipContainer';

import './SubtitleTrack.scss';

ApTimelineRow.register();
ApTimelineMetadata.register();
ApTimelineMarker.register();

export interface SubtitleTrackProps {
    subtitleTrackData: TimelineRow;
    selectedRowId: string;
    enabled: boolean;
    tooltipMarker?: TooltipMarker;
    setSubtitleContainerRef: () => void;
    setSubtitleRef: () => void;
    onRowClicked: () => void;
    onToggleEnabled: () => void;
}

const getButtonIcon = (enabled: boolean) => {
    if (enabled)
        return (<Visibility className="visibility-icon" />);
    
    return (
        <VisibilityOff
            className="visibility-icon"
            color="disabled"
        />
    );
};

const getTooltip = (tooltip: TooltipMarkerOrUndefined) => {
    if (!tooltip)
        return null;
    
    const {
        headerText,
        text,
        left,
        top,
        width,
        maxRight,
    } = tooltip;
    
    return (
        <Tooltip
            text={text}
            headerText={headerText}
            targetLeft={left}
            targetTop={top}
            targetWidth={width}
            maxRight={maxRight}
        />
    );
};

export default function SubtitleTrack(props: SubtitleTrackProps) {
    const {
        subtitleTrackData,
        setSubtitleContainerRef,
        setSubtitleRef,
        onRowClicked,
        onToggleEnabled,
        enabled,
        tooltipMarker,
        selectedRowId,
    } = props;
    const {label, identifier} = subtitleTrackData;
    const buttonIcon = getButtonIcon(enabled);
    const tooltip = getTooltip(tooltipMarker);
    const selected = selectedRowId === identifier;
    
    return (
        <div>
            <ap-timeline-row
                class={classNames('subtitle-row', {
                    selected,
                })}
                onClick={onRowClicked}
            >
                <span
                    slot="header"
                    className="subtitle-header"
                >
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        className={classNames('subtitle-header__label', {
                            disabled: !enabled,
                        })}
                    >
                        {label}
                    </Typography>
                    <QCTooltip
                        title="Toggle Caption on/off"
                        arrow
                    >
                        <ButtonBase
                            onClick={onToggleEnabled}
                            aria-label="Toggle Caption on/off"
                            className="toggle-track-button"
                        >
                            {buttonIcon}
                        </ButtonBase>
                    </QCTooltip>
                </span>
                <ap-timeline-metadata
                    ref={setSubtitleContainerRef}
                    padding={7}
                    class={classNames('subtitle-metadata', {
                        hover: tooltipMarker,
                    })}
                >
                    <ap-timeline-marker ref={setSubtitleRef} />
                </ap-timeline-metadata>
            </ap-timeline-row>
            {tooltip}
        </div>
    );
}
